// extracted by mini-css-extract-plugin
export default {"dropdownBox":"style_dropdownBox__xe4T5","box":"style_box__fX12R","active":"style_active__o35uW","title":"style_title__AnDk1","item":"style_item__qY99B"};